import SettingsEditor from './SettingEditor';

export default SettingsEditor;
